var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawDollarSignSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:1.91px;}.cls-1{stroke-linecap:square;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "withdrawl_dollar",
    "data-name": "withdrawl dollar"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.09,16.77h2.39a1.43,1.43,0,0,0,1.43-1.43h0a1.43,1.43,0,0,0-1.43-1.43h-1a1.43,1.43,0,0,1-1.43-1.43h0a1.43,1.43,0,0,1,1.43-1.43h2.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 9.14,
    x2: 12,
    y2: 11.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12,
    y1: 16.77,
    x2: 12,
    y2: 18.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.5 1.5 22.5 11.04 17.73 11.04 17.73 6.27 6.27 6.27 6.27 11.04 1.5 11.04 1.5 1.5 22.5 1.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.27,
    y1: 6.27,
    x2: 17.73,
    y2: 6.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.27,
    y: 6.27,
    width: 11.45,
    height: 16.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.36,
    y1: 6.27,
    x2: 19.64,
    y2: 6.27
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawDollarSignSvgrepoCom);
export default __webpack_public_path__ + "static/media/withdraw-dollar-sign-svgrepo-com.052c6d57d6a024cd1d15ddde526468d4.svg";
export { ForwardRef as ReactComponent };